import React from 'react';

const Coins = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.2662 13.9583C17.9912 16.175 16.1746 17.9917 13.9579 18.2667C12.6162 18.4333 11.3662 18.0667 10.3912 17.35C9.83289 16.9417 9.96623 16.075 10.6329 15.875C13.1412 15.1167 15.1162 13.1333 15.8829 10.625C16.0829 9.96667 16.9496 9.83334 17.3579 10.3833C18.0662 11.3667 18.4329 12.6167 18.2662 13.9583Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.32533 1.66667C4.65033 1.66667 1.66699 4.65 1.66699 8.325C1.66699 12 4.65033 14.9833 8.32533 14.9833C12.0003 14.9833 14.9837 12 14.9837 8.325C14.9753 4.65 12.0003 1.66667 8.32533 1.66667ZM7.54199 7.39167L9.55033 8.09167C10.2753 8.35001 10.6253 8.85834 10.6253 9.64167C10.6253 10.5417 9.90866 11.2833 9.03366 11.2833H8.95866V11.325C8.95866 11.6667 8.67533 11.95 8.33366 11.95C7.99199 11.95 7.70866 11.6667 7.70866 11.325V11.275C6.78366 11.2333 6.04199 10.4583 6.04199 9.49167C6.04199 9.15001 6.32533 8.86667 6.66699 8.86667C7.00866 8.86667 7.29199 9.15001 7.29199 9.49167C7.29199 9.79167 7.50866 10.0333 7.77533 10.0333H9.02533C9.21699 10.0333 9.36699 9.85834 9.36699 9.64167C9.36699 9.35 9.31699 9.33334 9.12533 9.26667L7.11699 8.56667C6.40033 8.31667 6.04199 7.80834 6.04199 7.01667C6.04199 6.11667 6.75866 5.375 7.63366 5.375H7.70866V5.34167C7.70866 5 7.99199 4.71667 8.33366 4.71667C8.67533 4.71667 8.95866 5 8.95866 5.34167V5.39167C9.88366 5.43334 10.6253 6.20834 10.6253 7.175C10.6253 7.51667 10.342 7.8 10.0003 7.8C9.65866 7.8 9.37533 7.51667 9.37533 7.175C9.37533 6.875 9.15866 6.63334 8.89199 6.63334H7.64199C7.45033 6.63334 7.30033 6.80834 7.30033 7.02501C7.29199 7.30834 7.34199 7.32501 7.54199 7.39167Z",
      fill: "white"
    }
  )
);
Coins.displayName = "Icons.Coins";

export { Coins };
//# sourceMappingURL=Coins.js.map
